export default __webpack_public_path__ + "static/media/hiddenfoilw.c622bfab.svg";